import classnames from "classnames";
import * as React from "react";
import { Link } from "react-router-dom";

interface CountBlockProps {
    count: number,
    label: string,
    action: () => void
}

const CountBlock: React.SFC<CountBlockProps> = (props: CountBlockProps) => {
    const { count, label, action } = props;
    const isDisabled = count === 0;
    const countBlockClasses = classnames({
        "c-count-block": true,
        "c-count-block--disabled": isDisabled
    });

    return (
        <div className={countBlockClasses} onClick={() => !isDisabled && action()}>
            <div className="c-count-block__inner">
                <div className="c-count-block__count">{count}</div>
                <div className="c-count-block__label">{label}</div>
            </div>
        </div>
    );
};

interface CountBlockContainerProps {
    title: string,
    jobId: number,
    countData: any[]
}

export const CountBlockContainer: React.SFC<CountBlockContainerProps> = (props: CountBlockContainerProps) => {
    const { title, countData } = props;

    return (
        <div className="c-block">
            <h2 id={title} className="c-block__title">
                {title}
            </h2>
            <div className="c-block__count-blocks">
                {countData.map((cd, i) => <CountBlock key={i} {...cd} />)}
            </div>
            <Link className="c-link c-link--magenta" to={"/referrals/?job_id=" + props.jobId}>
                view all referrals
            </Link>
        </div>
    );
};

export default CountBlockContainer;
